import { takeLatest, call, put } from "redux-saga/effects";
import aitsApi from "./aitsApi";

import {
  fetchAitsTestListRequest,
  fetchAitsTestListSuccess,
  fetchAitsTestListFailure,
} from "./aitsSlice";

function* fetchAitsTestListWorker(action) {
  try {
    const {
      paperType,
      plannerId,
      plannerTestType,
      page,
      year,
      format,
      categoryId,
    } = action.payload;

    const response = yield call(aitsApi.getAitsTestList, {
      paperType,
      plannerId,
      plannerTestType,
      page,
      year,
      format,
      categoryId,
    });

    if (response?.status === 200) {
      const tabs = response?.tabs || response?.data?.tabs || ["All Tests"];

      const list = response?.data?.data || [];

      yield put(fetchAitsTestListSuccess({ list, tabs }));
    } else {
      throw new Error(response?.message || "Invalid API response");
    }
  } catch (error) {
    yield put(fetchAitsTestListFailure(error.message));
  }
}

export default function* aitsSaga() {
  yield takeLatest(fetchAitsTestListRequest.type, fetchAitsTestListWorker);
}
